import { useRef } from 'react'
import { Table } from 'antd'
import styles from '@Orders/OrderDetailsPage/styles.css'

import Box from '~/core/Box'

type OrderedItemsTableType = {
    COLUMNS: Array<any>
    dataSource?: Array<any>
    onRowClick: Function
    pagination: any
    toggleModalForPartViewer: Function
    setActivePage: (page: string) => void
}

export const OrderedItemsTable = (props: OrderedItemsTableType) => {
    const {
        COLUMNS,
        dataSource,
        onRowClick,
        pagination,
        toggleModalForPartViewer,
        setActivePage,
    } = props
    const orderedItemsTableRef = useRef<HTMLDivElement>(null)

    const onPaginationChange = () =>
        orderedItemsTableRef?.current?.scrollIntoView()

    return (
        <>
            <Table
                ref={orderedItemsTableRef}
                className={styles.shippingTableStyle}
                columns={COLUMNS}
                dataSource={dataSource || []}
                pagination={false}
                onRow={partData =>
                    onRowClick(
                        partData,
                        toggleModalForPartViewer,
                        setActivePage,
                    )
                }
                scroll={{
                    x: 1180,
                }}
                data-test-target="ordered-items"
            />
            <Box justifyContent="end">{pagination(onPaginationChange)}</Box>
        </>
    )
}
